// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.browser {
  width: 1200px;
  /* height: 350px; */
  overflow: hidden;
  border-radius: 10px;
  /* box-shadow: 0px 20px 25px 10px rgba(0, 0, 0, .4); */
  margin: auto
}

.toolbar {
  /* background-color: #E6E6E6; */
  width: auto;
  height: 35px;
  border-radius: 10px 10px 0 0;
}

.tab {
  border-bottom: 15px solid #E6E6E6;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-radius: 5px 5px 0 0;
  height: 23px;
  width: 110px;
  display: inline-block;
}

.tabbar {
background-color: #E6E6E6;
width: auto;
height: 23px;
}

.btn {
width: 10px;
height: 10px;
border-radius: 15px;
float: left;
/* margin: 8px 5px 0 0; */
box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, .05);
}
.btn:first-of-type {
margin-left: 10px;
}

.close {
  background-color: #E06752;
}

.min {
  background-color:  #ecc343;
}

.max {
  background-color: #57d08d;
}

.viewport {
  background-color: #fff;
  width: auto;

  /* height: 300px; */
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid #CBCBCB;
  border-radius: 0 0 10px 10px;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/product/create/product-create-wizard/product-type-wizard-step/product-type-preview/product-type-preview.component.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sDAAsD;EACtD;AACF;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;AACA,yBAAyB;AACzB,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB,WAAW;AACX,yBAAyB;AACzB,8CAA8C;AAC9C;AACA;AACA,iBAAiB;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;;EAEX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,w7EAAw7E","sourcesContent":["\n.browser {\n  width: 1200px;\n  /* height: 350px; */\n  overflow: hidden;\n  border-radius: 10px;\n  /* box-shadow: 0px 20px 25px 10px rgba(0, 0, 0, .4); */\n  margin: auto\n}\n\n.toolbar {\n  /* background-color: #E6E6E6; */\n  width: auto;\n  height: 35px;\n  border-radius: 10px 10px 0 0;\n}\n\n.tab {\n  border-bottom: 15px solid #E6E6E6;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-radius: 5px 5px 0 0;\n  height: 23px;\n  width: 110px;\n  display: inline-block;\n}\n\n.tabbar {\nbackground-color: #E6E6E6;\nwidth: auto;\nheight: 23px;\n}\n\n.btn {\nwidth: 10px;\nheight: 10px;\nborder-radius: 15px;\nfloat: left;\n/* margin: 8px 5px 0 0; */\nbox-shadow: 0px 2px 2px 1px rgba(0, 0, 0, .05);\n}\n.btn:first-of-type {\nmargin-left: 10px;\n}\n\n.close {\n  background-color: #E06752;\n}\n\n.min {\n  background-color:  #ecc343;\n}\n\n.max {\n  background-color: #57d08d;\n}\n\n.viewport {\n  background-color: #fff;\n  width: auto;\n\n  /* height: 300px; */\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-top: 1px solid #CBCBCB;\n  border-radius: 0 0 10px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
